
const { root, index } = window.config;

let callback;

function routes( cb ) {
    callback = cb;
    let pathname = location.pathname,
        hash     = location.hash;
    if ( hash ) {
        pathname = hash.replace( /^#/i, '' );
    }
    console.log( 'current url: ', pathname )
    switch ( true ) {
        case pathname.startsWith( '/' ) && !pathname.endsWith( '/' ) && pathname.replace( '/', '' ) == root.replace( '/', '' ):
            //location.href = location.origin + '/' + root;
            callback({ type: 'refresh', path: location.origin + '/' + root });
            break;
        case '/' == pathname:
        case root + index == pathname:
        case root + index != '' && pathname.endsWith( root + index ):
            //this.getPosts();
            callback({ type: 'posts', path: '' });
            break;
        case /\/?post\/\d+/i.test( pathname ):
            //this.getPost( pathname.replace( root + index, '' ).replace( /\/?post\//i, '' ));
            callback({ type: 'post', path: pathname.replace( root + index, '' ).replace( /\/?post\//i, '' )});
            break;
        case /\/?memos/i.test( pathname ):
            callback({ type: 'memos', path: pathname.replace( root + index, '' ).replace( /\/?post\//i, '' )});
            break;
        case /\/?inbox/i.test( pathname ):
            callback({ type: 'inbox', path: pathname.replace( root + index, '' ).replace( /\/?post\//i, '' )});
            break;
        case pathname.replace( root + index, '' ).startsWith( '/tag/' ) && !pathname.replace( root + index, '' ).endsWith( '/tag/' ):
            //this.getPosts( decodeURIComponent( pathname.replace( root + index, '' ) ).replace( /\/tag\//i, '' ));
            callback({ type: 'tag', path: decodeURIComponent( pathname.replace( root + index, '' ) ).replace( /\/tag\//i, '' )});
            break;
        default:
            console.log( 'routers: ', 404 )
            // test
            //callback({ type: 404, path: 404 });
            break;
    }
}

window.addEventListener( 'popstate', event => {
    let state = event.state,
        hash  = location.hash;
    if ( hash ) {
        state = hash.replace( /^#/i, '' );
    }
    console.log( 'current history url: ', state )
    if ( state == null ) {
        state = location.pathname;
    }
    switch ( true ) {
        case '/' == state:
        case root == state:
        case root + index == state:
        case root + index != '' && state.endsWith( root + index ):
        case state == null:
        case state.startsWith( '/' ) && state.replace( /\//ig, '' ) == root.replace( '/', '' ):
            //this.getPosts();
            callback({ type: 'posts', path: '' });
            break;
        case /\/?post\/\d+/i.test( state ):
            //this.getPost( state.replace( root + index, '' ).replace( /\/?post\//i, '' ));
            callback({ type: 'post', path: state.replace( root + index, '' ).replace( /\/?post\//i, '' )});
            break;
        case state.replace( root + index, '' ).startsWith( '/tag/' ) && !state.replace( root + index, '' ).endsWith( '/tag/' ):
            //this.emptyRender( this.$posts );
            //this.getPosts( decodeURIComponent( state.replace( root + index, '' ) ).replace( /\/tag\//i, '' ));
            callback({ type: 'tag', path: decodeURIComponent( state.replace( root + index, '' ) ).replace( /\/tag\//i, '' ), empty: true });
            break;
        default:
            console.log( 'routers: ', 404 )
            callback({ type: '404', path: 404 });
            break;
    }
});

function updateURL( url ) {
    console.log( 'current change url: ', url )
    if ( url == '/' && window.config.root ) {
        url = '/' + window.config.root;
    } else if ( url != '/' && !url.startsWith( '/' )) {
        url = '/' + window.config.root + url;
    }
    history.pushState( url, '', url );
}

module.exports = {
    routes, updateURL
};